import { isAuthenticatedUser } from 'js/lib/user';

import type { QuestionValue } from 'bundles/onboarding-common/types';
import type { LocalStorageQuestionIds } from 'bundles/onboarding-common/types/LocalStorage';
import { getLocalStorageOnboardingData } from 'bundles/onboarding-common/utils/localStorageUtils';

type ExtendedQuestionValue = QuestionValue & { loading: boolean };

const useFetchData = <T extends ExtendedQuestionValue>({
  useQueryData,
  questionIdForLocalStorage,
  skip,
}: {
  useQueryData: ({ skip }: { skip?: boolean }) => T;
  questionIdForLocalStorage: LocalStorageQuestionIds;
  skip?: boolean;
}): T => {
  const isUnregisteredUser = !isAuthenticatedUser();
  const queryData = useQueryData({ skip: isUnregisteredUser || skip });

  if (skip) {
    return {
      value: null,
      loading: false,
      __typename: questionIdForLocalStorage,
    } as T;
  } else if (isUnregisteredUser) {
    const localStorageData = getLocalStorageOnboardingData()?.[questionIdForLocalStorage];

    return {
      value: localStorageData?.value,
      loading: false,
      __typename: questionIdForLocalStorage,
    } as T;
  } else {
    return queryData;
  }
};

export default useFetchData;
